class FileLoader {
  async loadBase64(file) {
    return await new Promise(resolve => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const base64StartIndex = fileReader.result.indexOf(',') + 1;
        const base64 = fileReader.result.substring(base64StartIndex);
        resolve(base64);
      };
      fileReader.readAsDataURL(file);
    });
  }
  createBase64ImageSrc(base64) {
    const mimeType = this.getMimeTypeFromBase64(base64);
    return `data:${mimeType};base64,${base64}`;
  }
  getMimeTypeFromBase64(base64) {
    if (base64.startsWith('/9j/')) {
      return 'image/jpg';
    }
    if (base64.startsWith('iVBORw0KGgo')) {
      return 'image/png';
    }
  }
}
const fileLoader = new FileLoader();
export default fileLoader;